import React from 'react';
import Box from '@/components/UI/box/Box';
import SimilarHousesContainer from '../houseInfo/similarHousesContainer/SimilarHousesContainer';
import HouseTags from '../houseInfo/houseTags/HouseTags';
import HouseBreadcrumb from '../houseInfo/houseBreadcrumb/HouseBreadcrumb';
import styles from './HouseInfoFooter.module.scss';
import { useMidTermQuery } from '../../_hooks/useMidterm';
const HouseInfoFooter = ({
  productState,
  host
}) => {
  const {
    isMidTerm
  } = useMidTermQuery(productState);
  return <>
      <Box component={'aside'} className={styles['similar-section']} data-sentry-element="Box" data-sentry-source-file="HouseInfoFooter.tsx">
        {!isMidTerm && <SimilarHousesContainer parentId={productState?.parent?.id} bookableStatus={productState?.bookable_status} />}

        <HouseTags tags={productState?.['house-tags']} data-sentry-element="HouseTags" data-sentry-source-file="HouseInfoFooter.tsx" />
      </Box>

      <HouseBreadcrumb data={productState} host={host} data-sentry-element="HouseBreadcrumb" data-sentry-source-file="HouseInfoFooter.tsx" />
    </>;
};
export default HouseInfoFooter;